import React from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../../AbstractElements';
import AustraliaMap from './Australia';
import IndiaMap from './IndiaMap';
import USAMap from './USAMap';
import WorldMap from './WorldMap';

const LeafletMapContain = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs pageTitle={'Leaflet Map'} parent={'Map'} title={'Leaflet Map'} />
      <Row>
        <WorldMap />
        <USAMap />
        <IndiaMap />
        <AustraliaMap />
      </Row>
    </Container>
  );
};
export default LeafletMapContain;
